import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { createSharedComposable } from '@vueuse/core';
import { AgentType } from '../constants/enum';

const VALID_AGENT_TYPES = new Set<string>(Object.values(AgentType));
const DEFAULT_TAB = AgentType.DISCLOSURE;

function getTabFromQuery(agent: string | undefined): AgentType {
    if (agent && VALID_AGENT_TYPES.has(agent)) return agent as AgentType;
    return DEFAULT_TAB;
}

export const useAgentTabs = createSharedComposable(() => {
    const route = useRoute();
    const router = useRouter();

    const activeTab = ref<AgentType>(getTabFromQuery(route.query.agent as string));

    watch(() => route.query.agent, (newAgent) => {
        activeTab.value = getTabFromQuery(newAgent as string);
    });

    function setActiveTab(tab: AgentType) {
        activeTab.value = tab;
        router.push({ query: { ...route.query, agent: tab } });
    }

    return { activeTab, setActiveTab };
});
